'use strict';

const $overlay = $('<div class="bottom-sheet-overlay"></div>');
const $body = $('body');

const BOTTOM_SHEET_SELECTOR = '.bottom-sheet-content';
/**
 * Actions required to open the bottom sheet
 * @param {Object} sheet - Sheet JQuery DOM element
 */
function openBottomSheet(sheet) {
    if(sheet) {
        sheet.addClass('show');
        $overlay.insertAfter(sheet);
        $overlay.addClass('show');
        $body.addClass('no-scroll');
    }
}

/**
 * Actions required to close the bottom sheet
 * @param {Object} sheet - Sheet JQuery DOM element
 */
function closeBottomSheet(sheet) {
    if (sheet) {
        sheet.removeClass('show');
        $overlay.removeClass('show');
        $body.removeClass('no-scroll');
        sheet.trigger('bottomSheetClosed');
    }
}

/**
 * Trigger on click
 * @param {JQuery.event} event - Click event
 */
function handleTriggerClick(requestOrEvent) {
    let targetId;

    if(requestOrEvent.targetId) {
        targetId = requestOrEvent.targetId;
    } else if(requestOrEvent.currentTarget){
        let $trigger = $(requestOrEvent.currentTarget);
        targetId = $trigger.data('target');
    }

    if(targetId) {
        const $sheet = $(`${targetId}`).find(BOTTOM_SHEET_SELECTOR);
        openBottomSheet($sheet);
    }
}

/**
 * Close
 * @param {JQuery.event} event - Click event
 */
function handleCloseClick(event) {
    const $close = $(event.currentTarget);
    const $sheet = $close.closest(BOTTOM_SHEET_SELECTOR);
    closeBottomSheet($sheet);
}

/**
 * Event for click outside bottomsheet
 */
function handleOverlayClick() {
    const $visibleSheet = $(BOTTOM_SHEET_SELECTOR + '.show');
    if ($visibleSheet.length) {
        closeBottomSheet($visibleSheet);
    }
}

/**
 * Start listeners
 */
function initBottomSheetEvents() {
    var trigersSelector = '.bottom-sheet-trigger';
    var closeTriggersSelector = '.bottom-sheet-close';
    $(document).on('click', trigersSelector,  handleTriggerClick);
    $(document).on('click', closeTriggersSelector,  handleCloseClick);
    $overlay.on('click', handleOverlayClick);

    $(document).on('openBottomSheetRequest', function(event, data) {
        if (data.targetId) {
            handleTriggerClick(data);
        }
    });

    $(document).on('closeBottomSheetRequest', function(event, data) {
        if (data.targetId) {
            closeBottomSheet(data.targetId);
        }
    });
}

/**
 * Entry point
 */
const initBottomSheet = function() {
    initBottomSheetEvents();
}

;

module.exports = {
    initBottomSheet: initBottomSheet
};
